/**
 * Component for our Report showing most-exchanged-from
 * Products.
 * 
 * @component
 */

import React from "react";
import Report from "../Report";

const columns = [
  {
    title: "Product Name",
    dataIndex: "productName",
    key: "productName"
  },
  {
    title: "Count",
    dataIndex: "productCount",
    key: "productCount"
  },
];

const exportHeaders = [
  {
    label: "Product Name",
    value: "productName",
  },
  {
    label: "Count",
    value: "productCount",
  },
];

class Products extends React.Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <Report
        url="/api/reports/exchanged-products/by-product"
        title="Most Exchanged Products"
        tooltip="This report shows how many times a product was exchanged within the selected date range."
        columns={columns}
        reportName="most-exchanged-products"
        exportHeaders={exportHeaders}
        startDate={this.props.startDate}
        endDate={this.props.endDate}
        updateDate={this.props.updateDate}
      />
    );
  }
}

export default Products;
